import { openContextModal } from "@mantine/modals";
import i18next from "i18next";

import * as Analytics from "../../../../packages/fxid-openapi-client/src/Analytics";
import { ModalParams } from "./ConfirmPurchaseWithPersonalInfoInputModal";

export const openConfirmPurchaseWithPersonalInfoModal = (props: ModalParams) => {
	const { analyticsData, onClose, ...innerProps } = props;

	void Analytics.site.openConfirmPurchaseWithPersonalInformation({
		...analyticsData
	});

	return openContextModal({
		modal: "confirmPurchaseWithPersonalInfoModal",
		title: i18next.t("login_from_email.message"),
		innerProps: { ...innerProps, onClose },
		size: "md",
		centered: true
	});
};
